import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LifeAtUHomes from '../components/LifeAtUHomes';
import { trackLifePageViewed } from '../src/lib/analytics';

const LifePage: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  // 更新页面标题
  useEffect(() => {
    document.title = `${t('nav.ourStory')} - ${t('html.title')}`;
    trackLifePageViewed();
  }, [t]);

  const handleSearchJobs = () => {
    navigate('/jobs');
  };

  const handleOffices = () => {
    navigate('/offices');
  };

  return (
    <LifeAtUHomes
      onSearchJobs={handleSearchJobs}
      onOffices={handleOffices}
    />
  );
};

export default LifePage;
